/**
 * Como o pedido e o serviço são chamados na bancada e nas etiquetas: o número sequencial do
 * pedido no laboratório (1042) e a posição do serviço nele (1042-2). Pedido a laboratório fora da
 * plataforma não tem número — cai nos 6 últimos caracteres do id, como antes.
 */
export function codigoDoPedido(pedido: { id: string; numero?: number | null }): string {
  return pedido.numero ? String(pedido.numero) : pedido.id.slice(-6).toUpperCase();
}

export function codigoDoServico(
  pedido: { id: string; numero?: number | null },
  servico: { ordem?: number | null },
): string {
  return `${codigoDoPedido(pedido)}-${servico.ordem ?? 1}`;
}
